import { useAnytimeDocumentList } from "@/api/services/main/any-time";
import { ConfirmDeleteModal } from "@/components/commons/ConfirmDeleteModal";
import { InnerBox } from "@/components/elements/InnerBox";
import { Pagination } from "@/components/elements/Pagination";
import { Table } from "@/components/elements/Table";
import { useDocumentListColumns } from "@/features/anytime/hooks/useDocumentListColumns";
import { useDialog } from "@/hooks/useDialog";
import { useTable } from "@/hooks/useTable";
import { DOCUMENT_STATUS } from "@/types/enum";
import { Stack } from "@mui/material";

export const DocumentList = () => {
  const { data: documentListResult, isLoading } = useAnytimeDocumentList();
  const documentListData = documentListResult?.data;
  const confirmDelete = useDialog();

  const columns = useDocumentListColumns();

  const { table } = useTable({
    columns,
    rows: documentListData ?? [],
    failedRow: (row) => row.status === DOCUMENT_STATUS.IN_PROGRESS,
    pinningColumns: ["action"],
  });

  return (
    <InnerBox title="作成済みの書類一覧">
      <Stack gap={2}>
        <Pagination totalPage={documentListResult?.pagination.totalPage} />
        <Table table={table} isLoading={isLoading} />
        <ConfirmDeleteModal
          open={confirmDelete.open}
          onClose={confirmDelete.cancel}
          onOk={confirmDelete.confirm}
          message="ドキュメントを削除してもよろしいですか?"
        />
      </Stack>
    </InnerBox>
  );
};
